import { useCallback, useMemo, useRef, useState } from 'react';
import { CategoryType } from 'src/graphql';
import { useRefsByKey } from 'src/hooks';
import { calculateItemJoinerCoordinates } from 'src/utils/reordering/calculateItemJoinerCoordinates';

interface Parameters {
  categories: Omit<CategoryType, 'Author'>[];
  draggingId: string | null;
}

export const useCategoryCoordinates = ({
  categories,
  draggingId,
}: Parameters) => {
  const categoryListontainerRef = useRef<HTMLDivElement>(null);
  const { refsByKey, setRef } = useRefsByKey();
  const [categoryJoinerCoordinates, setCategoryJoinerCoordinates] = useState<
    (number[] | null[])[]
  >([]);

  const orderedCategories = useMemo(
    () =>
      categories.map((category) => ({
        ...category,
        id: category.id.toString(),
      })),
    [categories],
  );

  const recalculateCoordinates = useCallback(() => {
    if (categories.length) {
      setCategoryJoinerCoordinates(
        categories.map((category, index) => {
          const coordinates = calculateItemJoinerCoordinates({
            item: { ...category, id: category.id.toString() },
            index,
            draggingId,
            orderedList: orderedCategories,
            listContainerRef: categoryListontainerRef,
            refsByKey,
          });

          return coordinates;
        }),
      );
    }
  }, [categories, draggingId, orderedCategories, refsByKey]);

  return {
    categoryListontainerRef,
    setRef,
    categoryJoinerCoordinates,
    recalculateCoordinates,
  };
};
